import ResizableDraggable from './ResizableDraggable';

export default ResizableDraggable;
